document.querySelectorAll(`[data-select-type="choicesjs"]`).forEach(el => {

    //only apply choices JS, if not in modal placeholder area 'modalcontent'
    if (el.closest(".modalcontent") === null) {

        let options = {
            removeItemButton: true,
            itemSelectText: "",
            placeholderValue: "Please select...",
            searchPlaceholderValue: "Type to filter..."
        }

        if (el.dataset.noFilter !== undefined) {
            options.searchEnabled = false
        }

        let choices = new Choices(el, options);
    }

});